import React, { useState, useEffect } from "react";
import styled from "styled-components";
import videoSource from "./images/grain4.mp4";
import { useMousePosition } from "./utils/MouseContext";

const BackgroundContainer = styled.div.attrs(({ $mouseX, $mouseY }) => ({
  style: {
    background: `radial-gradient(circle at ${$mouseX}px ${$mouseY}px, rgba(65, 65, 65, 1), rgba(12, 12, 12, 1) 100%)`
  }
}))`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  pointer-events: none;
  z-index: -2;
`;

const ImageOverlay = styled.div.attrs(({ $resolvedImage, $isVisible }) => ({
  style: {
    background: $resolvedImage ? `url(${$resolvedImage}) no-repeat center center / cover` : 'none',
    opacity: $isVisible ? 1 : 0
  }
}))`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: opacity 0.6s ease;
  filter: blur(7px);
  z-index: -1;
`;

const VideoOverlay = styled.video`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0.01;
  z-index: -1;
  pointer-events: none;
`;

function Background({ backgroundImage }) {
  const [resolvedImage, setResolvedImage] = useState(null);
  const [isVisible, setIsVisible] = useState(false);
  const [isSvg, setIsSvg] = useState(false);
  const { mousePosition, setMousePosition } = useMousePosition();

  useEffect(() => {
    const handleMouseMove = (e) => {
      setMousePosition({ x: e.clientX, y: e.clientY });
    };

    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, [setMousePosition]);

  useEffect(() => {
    if (backgroundImage) {
      setIsSvg(backgroundImage.endsWith(".svg"));
      if (isSvg) {
        fetch(backgroundImage)
          .then((response) => response.text())
          .then((svgText) => {
            const base64SVG = btoa(svgText);
            setResolvedImage(`data:image/svg+xml;base64,${base64SVG}`);
            setIsVisible(true);
          })
          .catch((error) => console.error("Error loading SVG:", error));
      } else {
        setResolvedImage(backgroundImage);
        setIsVisible(true);
      }
    } else {
      setIsVisible(false);
    }
  }, [backgroundImage, isSvg]);

  return (
    <>
      <BackgroundContainer
        $mouseX={mousePosition.x}
        $mouseY={mousePosition.y}
      />
      <ImageOverlay
        $resolvedImage={resolvedImage}
        $isVisible={isVisible}
      />
      <VideoOverlay autoPlay muted loop playsInline>
        <source src={videoSource} type="video/mp4" />
      </VideoOverlay>
    </>
  );
}

export default Background;
